import { render } from "./ParserSettings.vue?vue&type=template&id=4c3d3bb0&scoped=true"
import script from "./ParserSettings.vue?vue&type=script&lang=js"
export * from "./ParserSettings.vue?vue&type=script&lang=js"

import "./ParserSettings.vue?vue&type=style&index=0&id=4c3d3bb0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3d3bb0"]])

export default __exports__